<template>
	<div class="w-full">
		<div class="mb-3">
			<span class="mb-0 font-medium text-gray-650">Price</span>
		</div>

		<div v-if="isDirty" class="m-0 space-y-3 p-0">
			<FilterSelectbox
				v-model="priceUsedFrom"
				mode="single"
				:options="priceUsedFromOptions"
				value-prop="value"
				label="label"
				placeholder="From"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'priceUsedFrom')"
			/>

			<FilterSelectbox
				v-model="priceUsedTo"
				mode="single"
				:options="priceUsedToOptions"
				value-prop="value"
				label="label"
				placeholder="To"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'priceUsedTo')"
			/>
		</div>

		<div v-if="showContentLoader" class="flex flex-col gap-2">
			<ContentLoader width="w-full" height="h-[50px]" />
			<ContentLoader width="w-full" height="h-[50px]" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import FilterSelectbox from '@/components/selectboxes/FilterSelectbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const priceUsedFrom = ref(
	productCatalog.filters.priceUsedFrom
		? productCatalog.filters.priceUsedFrom
		: 'all'
)
const priceUsedTo = ref(
	productCatalog.filters.priceUsedTo
		? productCatalog.filters.priceUsedTo
		: 'all'
)

const priceUsedFromOptionsOriginal = computed(
	() => productCatalog.facets.priceUsedFrom
)

const priceUsedToOptionsOriginal = computed(
	() => productCatalog.facets.priceUsedTo
)

const priceUsedFromOptions = computed(() => {
	const options = []
	priceUsedFromOptionsOriginal.value.forEach((option) => {
		if (
			priceUsedTo.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) >= parseInt(priceUsedTo.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const priceUsedToOptions = computed(() => {
	const options = []
	priceUsedToOptionsOriginal.value.forEach((option) => {
		if (
			priceUsedFrom.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) <= parseInt(priceUsedFrom.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

watch(
	() => productCatalog.filters.priceUsedFrom,
	(newValue) => {
		priceUsedFrom.value =
			newValue === null || newValue === '' ? 'all' : newValue
	}
)

watch(
	() => productCatalog.filters.priceUsedTo,
	(newValue) => {
		priceUsedTo.value =
			newValue === null || newValue === '' ? 'all' : newValue
	}
)

const onChange = (filterValue, filterKey) => {
	let updateFilterValue = filterValue

	// handle when 'all' is selected
	if (updateFilterValue === 'all') {
		updateFilterValue = null
	}

	productCatalog.updateFilter({
		filterKey,
		filterValue: updateFilterValue,
	})
}
</script>
